import React from 'react'
import styled from 'styled-components';

import { Link } from "react-router-dom";


const StyledDesktopNav = styled.nav``;

const StyledUL = styled.ul`
    list-style: none;
    display: flex;
    justify-content: end;
    gap: 3em;
    padding: 3em 2em 2em 2em;
    &>li {
        &>*{
            &>p {
            font-size: 1.5rem;
            font-family: kenoky;
            display: block;
            position: relative;
            padding: 0.1em 0;
            padding-right: .5em;
            overflow: hidden;
        }
        
        &>p:after{
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0.09em;
            background-color: black;
            opacity: 0;
            transition: opacity 300ms, transform 300ms;
            transform: translate3d(-100%, 0, 0);
        }        
        
        p:hover::after,
        p:focus::after {
            opacity: 1;
            transform: translate3d(0, 0.2em, 0);
            transform: translate3d(0, 0, 0);
        }
        
        }
        
    }
    `;



export default function DesktopNav() {
    return (
      <StyledDesktopNav>
        <StyledUL>
          <li>
            <Link to="/">
              {' '}
              <p>Home</p>
            </Link>
          </li>
          <li>
            <Link to="/about">
              {' '}
              <p>About</p>
            </Link>
          </li>
          {/* <li>
                    <Link to='/projects'> <p>Projects</p></Link>
                </li> */}
          <li>
            <Link to="/contact">
              {' '}
              <p>Contact</p>
            </Link>
          </li>
        </StyledUL>
      </StyledDesktopNav>
    );
}
